import * as React from 'react'
import BannerCarousel from 'src/components/front-page/banner-carousel/banner-carousel.conn'
import NewsList from 'src/components/front-page/news-list/news-list.conn'
import Testimonies from 'src/components/front-page/testimonies/testimonies.conn'
import InstagramCarousel from 'src/components/front-page/instagram-carousel/instagram-carousel.conn'
import Header from 'src/components/Shared/header/header'
import * as ReactGA from 'react-ga'
import AnnouncementOverlay from 'src/components/Shared/announcementOverlay/announcementOverlay.conn'

interface IState {
  hidden: boolean
}

export default class FrontPage extends React.Component<any, IState> {
  constructor(props: any) {
    super(props)
    this.showOverlay = this.showOverlay.bind(this)
    this.hideOverlay = this.hideOverlay.bind(this)
    this.hideOverlayButton = this.hideOverlayButton.bind(this)
    this.state = {
      hidden: true,
    }
  }

  showOverlay(e: any) {
    e.preventDefault()
    this.setState({ hidden: false })
  }
  hideOverlay(e: any) {
    if (e.target.id === 'dude') {
      this.setState({ hidden: true })
    }
  }
  hideOverlayButton() {
    this.setState({ hidden: true })
  }

  render() {
    // const { children } = this.props;
    window.scrollTo(0, 0)
    ReactGA.pageview(window.location.pathname + window.location.search)
    return (
      <div>
        <Header transparent={true} />
        <BannerCarousel />
        <NewsList />
        <Testimonies />
        <InstagramCarousel frontpage />
        <AnnouncementOverlay />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/FrontPage.tsx